import {createFileRoute} from '@tanstack/react-router';

import PatientRecoverPassword from '@/practitioner/views/patient/PatientRecoverPassword';

export const Route = createFileRoute('/(practitioner)/patients/$patientId/recover-password')({
  component: PatientRecoverPassword,
  loader: ({params}) => ({
    patientId: params.patientId
  })
});
